import React, { Component } from 'react';
import Page from '../../components/Page';
import { connect } from 'react-redux';
import { List, ListItem, Button, Typography, Stack, Divider, CircularProgress, Box, Modal } from '@mui/material';
import _ from 'lodash';
//import styled from '@emotion/styled';
import CodeIcon from '@mui/icons-material/Code';
import * as GA from '../../util/GA';

/* const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fafafa',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
})); */

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
	textAlign: 'center',
};
class Webhook extends Component {
	state = {
		loading: true,
	};

	async componentDidMount() {
		let uri = `https://api.maytapi.com/api/${this.props.product.id}/product?token=${this.props.product.settings.wapi_token}`;
		let phoneuri = `https://api.maytapi.com/api/${this.props.product.id}/listPhones?token=${this.props.product.settings.wapi_token}`;
		let data = await fetch(uri, { headers: { 'Content-Type': 'application/json' }, method: 'get' }).then((it) => it.json());
		let jsonFile = await fetch('https://maytapi.com/documentations/Maytapi_WhatsApp.postman_collection.json');
		let json = await jsonFile.json();
		let phones = await fetch(phoneuri, { headers: { 'Content-Type': 'application/json' }, method: 'get' }).then((it) => it.json());
		this.setState({ JsonFile: json, wapiData: data, phones: _.filter(phones, { type: 'whatsapp' }), loading: false });
	}
	downloadJson = async () => {
		let { phones, JsonFile } = this.state;
		const ProductId = this.props.product.settings.pid || this.props.product.id;
		const WapiToken = this.props.product.settings.wapi_token;
		const PhoneId = (phones && phones[0] && phones[0].id) || 'YOUR_PHONE_ID';
		let jsonString = JSON.stringify(JsonFile).replace('YOUR_PRODUCT_ID', ProductId).replace('YOUR_API_TOKEN', WapiToken).replace('YOUR_PHONE_ID', PhoneId);
		var a = document.createElement('a');
		a.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(jsonString);
		a.target = '_blank';
		a.download = 'Maytapi_WhatsApp.postman_collection.json';
		a.click();
		GA.event({ action: 'download-postman', category: 'analyze', label: 'Postman Download', value: 1 });
	};
	render() {
		let { loading, phones } = this.state;
		let PhoneId = (phones && phones[0] && phones[0].id) || '';
		if (loading)
			return (
				<Page title="Developers" subtitle="Postman Collection" icon={<CodeIcon />}>
					<Stack sx={{ marginTop: '20%', marginLeft: '50%' }} attached="bottom">
						<CircularProgress disableShrink />
					</Stack>{' '}
				</Page>
			);
		return (
			<Page title="Developers" subtitle="Postman Collection" icon={<CodeIcon />}>
				<Stack spacing={2} sx={{ marginTop: '15px', marginBottom: '10px', padding: '8px' }}>
					<h2 style={{ textAlign: 'center' }}>WhatsApp API Postman Collection</h2>
					<div style={{ marginLeft: '16px' }}>
						<Divider textAlign="left">
							<Typography variant="h5" gutterBottom component="div">
								Postman Collection Page
							</Typography>
						</Divider>
						<br />
						<Button
							sx={{ ':hover': { backgroundColor: '#ee6838', color: 'white' }, backgroundColor: '#FE6D39', color: 'white', marginTop: '15px' }}
							as="a"
							href="https://www.postman.com/maytapi-whatsapp-api/workspace/whatsapp-api-maytapi/overview"
							target="_blank"
						>
							Open Postman Collection
						</Button>
					</div>
					<List style={{ textAlign: 'left' }}>
						<ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<Divider textAlign="left">
								<Typography variant="h5" gutterBottom component="div">
									1. Download collection
								</Typography>
							</Divider>
							<Typography>Look at the collection.</Typography>
							<Button
								sx={{ ':hover': { backgroundColor: '#e69602' }, backgroundColor: 'orange', color: 'white', marginTop: '10px' }}
								onClick={() => (PhoneId ? this.downloadJson() : this.setState({ opendocumentmodal: true }))}
							>
								Download Collection
							</Button>
						</ListItem>
						<ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<Divider textAlign="left" sx={{ marginBottom: '10px' }}>
								<Typography variant="h5" gutterBottom component="div">
									2. Import collection to Postman
								</Typography>
							</Divider>
							<Typography>Click Import and select Collection file.</Typography>
							<div style={{ display: 'flex' }}>
								<img
									src="/postman_1.png"
									alt="postman_1"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
									onClick={() => window.open('/postman_1.png', '_target')}
								/>
								<img
									src="/postman_2.png"
									alt="postman_2"
									onClick={() => window.open('/postman_2.png', '_target')}
									style={{
										width: '48%',
										marginLeft: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
						<ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<Divider textAlign="left" sx={{ marginBottom: '10px' }}>
								<Typography variant="h5" gutterBottom component="div">
									3. Check your variables
								</Typography>
							</Divider>
							<Typography>
								Collection created with your Product ID, token and first Phone ID. If you want use another phone, must change on Postman.
							</Typography>

							<div>
								<img
									src="/postman_3.png"
									alt="postman_3"
									onClick={() => window.open('/postman_3.png', '_target')}
									style={{ width: '100%', boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)', marginTop: '20px', cursor: 'pointer' }}
								/>
							</div>
						</ListItem>
					</List>
					{/*no phone document modal*/}

					<Modal
						sx={{ background: '#000000ad' }}
						hideBackdrop
						open={this.state.opendocumentmodal}
						disableAutoFocus={true}
						onClose={() => this.setState({ opendocumentmodal: false })}
						aria-labelledby="child-modal-title"
						aria-describedby="child-modal-description"
					>
						<Box sx={style}>
							<Button
								onClick={() => this.setState({ opendocumentmodal: false })}
								sx={{ right: '0', top: '0', position: 'absolute', ':hover': { background: 'none' } }}
							>
								x
							</Button>
							<Typography id="modal-modal-title" variant="h6" component="h2">
								<p>You must have at least one phone id for using Maytapi Documents.</p>
								<p>Are you sure download without phone id?</p>
							</Typography>
							<Typography id="modal-modal-description" sx={{ mt: 2 }}>
								<Button fullWidth sx={{ backgroundColor: 'red', margin: '10px 0 10px 0' }} link={'/'}>
									Add Phone
								</Button>
								<Button fullWidth sx={{ backgroundColor: 'orange', margin: '10px 0 10px 0' }} onClick={() => this.downloadJson()}>
									Download Postman Collection
								</Button>
							</Typography>
						</Box>
					</Modal>
				</Stack>
			</Page>
		);
	}
}

export default connect((state) => ({ user: state.access.user.loggedUserObj, product: state.product.maytapi }))(Webhook);
